import options from './toolbar.component';

export default {
    selector: 'dtDetailViewToolbar',
    options
};
